import { render, staticRenderFns } from "./GameBoardTileComponent.vue?vue&type=template&id=6d1cd4ef&"
import script from "./GameBoardTileComponent.vue?vue&type=script&lang=ts&"
export * from "./GameBoardTileComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GameBoardTileComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports